import {NgModule} from "@angular/core";
import {RouterModule} from '@angular/router';
import { CommonModule } from '@angular/common';
import {BreadcrumbsComponent} from './breadcrumbs.component';
import { ModuleWithProviders } from '@angular/core';


@NgModule({
    imports     : [RouterModule, CommonModule],
    declarations: [BreadcrumbsComponent],
    exports: [BreadcrumbsComponent]
})

export class BreadcrumbsModule {}



// WEBPACK FOOTER //
// ./src/app/components/common/breadcrumbs/breadcrumbs.module.ts